import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

function LoaderPage() {

  const navigate = useNavigate();
  const { numAnnonce } = useParams()
    
  useEffect(() => {
      
      if( window.location.pathname.includes("certificate-checking")){
        navigate(`/certificate-checking/${numAnnonce}`)
      }
      else if (localStorage.getItem('userId') === null) {
          setTimeout(() => {
            navigate('/login');
          }, 2000); // Ajout d'un délai (par exemple, 1.5 secondes)
      } else {
        setTimeout(() => {
          navigate('/home');
        }, 2000);
      }
  }, [navigate]);

  return (
    <div className='div-spinner'>
      <div className="spinner-square">
        <div className="square-1 square"></div>
        <div className="square-2 square"></div>
        <div className="square-3 square"></div>
      </div>
    </div>
  );
}

export default LoaderPage;
